// eslint-disable-next-line import/prefer-default-export
export const GLOBAL_MEDIA_QUERIES = {
  mobile: '(max-width: 768px)', // mobile-tablet
  desktop: '(min-width: 769px)', // desktop
};
